<template>
    <div class="white-button trademark-button" :class="{ active: isFilterActive }" v-if="hasEligibleProducts">
        <button
            type="button"
            class="text-uppercase-based-on-eshop shop-button"
            @click="setFilter()"
            :title="canViewCount > 0 ? category.title : __('frontend_js.category.no-products-via-filter')"
        >
            <span>{{ category.title }}</span>
            <span v-if="canViewCount"> ({{ category.number_of_products }}) </span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        category: { required: true },
        canViewCount: { required: false },
    },

    computed: {
        filters() {
            return this.$store.getters['product-filters/filters'];
        },
        isFilterActive() {
            return this.filters.categories.includes(this.category.id);
        },
        hasEligibleProducts() {
            return this.category.number_of_products > 0;
        },
    },

    methods: {
        setFilter() {
            this.$store.commit('product-list/SET_LOADING', true);

            setTimeout(() => {
                this.$store.commit('product-filters/SET_FILTER', {
                    key: 'categories',
                    value: [this.category.id],
                });

                setTimeout(() => {
                    this.$root.$emit('filterChanged');
                }, 10);
            }, 10);
        },
    },
};
</script>
